var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4993 18.6671H11.6677L11.6693 18.6521C11.887 17.5864 12.3129 16.5743 12.9227 15.6737C13.8301 14.3367 15.1029 13.289 16.5893 12.6554C17.0927 12.4421 17.6177 12.2787 18.1527 12.1704C19.2625 11.9454 20.4062 11.9454 21.516 12.1704C23.111 12.4972 24.5745 13.2861 25.7243 14.4387L28.0843 12.0854C27.0207 11.0214 25.7623 10.1721 24.3777 9.58372C23.6715 9.28477 22.9374 9.05697 22.186 8.90372C20.6357 8.58874 19.038 8.58874 17.4877 8.90372C16.7358 9.05761 16.001 9.28595 15.2943 9.58538C13.2119 10.4689 11.4292 11.9355 10.161 13.8087C9.30749 15.0718 8.71062 16.4904 8.40435 17.9837C8.35768 18.2087 8.33268 18.4387 8.29935 18.6671H3.16602L9.83268 25.3337L16.4993 18.6671ZM23.166 22.0004H27.9977L27.996 22.0137C27.5605 24.15 26.3014 26.0289 24.491 27.2437C23.5907 27.854 22.5785 28.28 21.5127 28.4971C20.4034 28.7221 19.2603 28.7221 18.151 28.4971C17.0854 28.2794 16.0733 27.8535 15.1727 27.2437C14.7304 26.9445 14.3174 26.6041 13.9393 26.2271L11.5827 28.5837C12.6469 29.6474 13.9059 30.4961 15.291 31.0837C15.9977 31.3837 16.736 31.6121 17.4827 31.7637C19.0324 32.0789 20.6297 32.0789 22.1793 31.7637C25.1669 31.1436 27.7948 29.3827 29.5043 26.8554C30.357 25.5933 30.9533 24.1758 31.2593 22.6837C31.3043 22.4587 31.331 22.2287 31.3643 22.0004H36.4993L29.8327 15.3337L23.166 22.0004Z",
    fill: "#4A5568"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.7e138e4746b58f996ab057e2e92d6591.svg";
export { ForwardRef as ReactComponent };